export default __webpack_public_path__ + "static/media/Plackart of the Steel Behemoth.13dae2fb.jpg";